import { Controller } from "@hotwired/stimulus"

// The approval page's funding gate (R5, KTD4): while the wallet can't cover
// month one the approve button stays off, so this watcher polls the live
// balance and reloads the moment the money lands — the server then renders
// the button enabled.
const POLL_INTERVAL_MS = 10_000
const POLL_DEADLINE_MS = 15 * 60 * 1000

export default class extends Controller {
  static values = { url: String, needed: Number }

  connect() {
    const startedAt = Date.now()
    this.timer = setInterval(() => {
      if (Date.now() - startedAt > POLL_DEADLINE_MS) return this.stop()
      this.check()
    }, POLL_INTERVAL_MS)
  }

  disconnect() {
    this.stop()
  }

  async check() {
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (!response.ok) return
      const { usdc } = await response.json()
      if (Number(usdc) >= this.neededValue) {
        this.stop()
        window.location.reload()
      }
    } catch {
      // The next tick tries again; an unreadable balance never breaks the page.
    }
  }

  stop() {
    if (this.timer) clearInterval(this.timer)
    this.timer = null
  }
}
